export const NEPTUNE_USDT_CW20_CONTRACT = 'inj1cy9hes20vww2yr6crvs75gxy5hpycya2hmjg9s';
